<template>
  <div class="form-page">
    <FormTabGuard>
      <FullForm />
    </FormTabGuard>
  </div>
</template>
<script>
// Components
import FullForm from '@/components/common/FullForm/FullForm.vue';
import FormTabGuard from '@/components/common/FormTabGuard/FormTabGuard.vue';
export default {
  name: 'FormPage',
  components: {
    FullForm,
    FormTabGuard
  }
};
</script>
